import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  TextField,
  Typography,
  useTheme
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

const ItinerarioForm = ({ onChange, initialValue }) => {
  const theme = useTheme()
  const [dias, setDias] = useState([]);

   // Efecto para setear el itinerario inicial al editar
   useEffect(() => {
    if (initialValue) {
      const parsedDias = parseHTMLToDias(initialValue);
      setDias(parsedDias);
    }
  }, [initialValue]);

  const handleAddDia = () => {
    setDias([
      ...dias,
      {
        ciudad: '',
        descripcion: '',
        actividades: []
      },
    ]);
  };

  const handleRemoveDia = (index) => {
    const updatedDias = [...dias];
    updatedDias.splice(index, 1);
    setDias(updatedDias);
  };

  const handleDiaChange = (index, field, value) => {
    const updatedDias = [...dias];
    updatedDias[index][field] = value;
    setDias(updatedDias);
  };

  const handleActividadChange = (indexDia, indexActividad, field, value) => {
    const updatedDias = [...dias];
    updatedDias[indexDia].actividades[indexActividad][field] = value;
    setDias(updatedDias);
  };

  const addActividad = (indexDia) => {
    const updatedDias = [...dias];
    updatedDias[indexDia].actividades.push({ titulo: '', descripcion: '' });
    setDias(updatedDias);
  };

   const removeActividad = (indexDia, indexActividad) => {
    const updatedDias = [...dias];
    updatedDias[indexDia].actividades.splice(indexActividad, 1);
    setDias(updatedDias);
  };

  const generarHTML = () => {
    const html = dias.map((dia, idx) => {
      const numeroDia = String(idx + 1).padStart(2, '0');
      return `
        <h3>DÍA ${numeroDia} ${dia.ciudad.toUpperCase()}</h3>
        <p>${dia.descripcion}</p>
        ${dia.actividades.length > 0
          ? `<p><strong>Excursiones opcionales:</strong></p>
              <ul>${dia.actividades.map((act) => `<li><strong>${act.titulo}:</strong> ${act.descripcion}</li>`).join('')}</ul>`
          : ''
        }
      `;
    }).join('');

    if (onChange) onChange(html);
  };

  const parseHTMLToDias = (html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
  
    const dias = [];
    const headers = tempDiv.querySelectorAll('h3');
  
    headers.forEach((header, index) => {
      const ciudad = header.textContent.replace(/DÍA \d{2} /, '').trim();
      const descripcionEl = header.nextElementSibling;
      const descripcion = descripcionEl?.textContent || '';
      const excursionesHeader = descripcionEl?.nextElementSibling;
      const ul = excursionesHeader?.nextElementSibling;
      const actividades = [];

      if (ul && ul.tagName === 'UL') {
        ul.querySelectorAll('li').forEach(li => {
          const text = li.textContent.trim();
          // Manejar ambos formatos:
          // Nuevo formato: "TITULO: Descripción"
          // Viejo formato: "Descripción" (sin título)
          if (text.includes(':')) {
            const [titulo, ...descParts] = text.split(':');
            actividades.push({
              titulo: titulo.trim(),
              descripcion: descParts.join(':').trim()
            });
          } else {
            actividades.push({
              titulo: '', // Título vacío para formato antiguo
              descripcion: text
            });
          }
        });
      }
  
      dias.push({
        ciudad,
        descripcion,
        actividades
      });
    });
  
    return dias;
  };

  useEffect(() => {
    generarHTML()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dias]);

  return (
    <div style={{ maxHeight: 'auto', minHeight: "400px" }}>
      <Box
        sx={{
          p: 2,
          height: "340px",
          border: `1px solid ${theme.palette.primary.main}`,
          overflowY: 'auto',
          margin: '0 auto'
        }}
        style={{
          display: "block",
          boxSizing: 'border-box',
          marginBottom: "1rem",
          paddingBottom: "0"
        }}
      >
        <Typography variant="h5" gutterBottom align="center">
          Itinerario del Viaje
        </Typography>

        {dias.map((dia, indexDia) => (
          <Card key={indexDia} sx={{ mb: 2 }} style={{border: '1px solid #ccc', marginBottom: "1rem"}}>
            <CardContent>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={11}>
                  <Typography variant="h6" gutterBottom>
                    DÍA {String(indexDia + 1).padStart(2, '0')}
                  </Typography>
                </Grid>

                <Grid item xs={1}>
                  <IconButton style={{color: theme.palette.error.main}} onClick={() => handleRemoveDia(indexDia)}>
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              </Grid>

              <TextField
                label="Ciudades"
                fullWidth
                margin="normal"
                value={dia.ciudad}
                onChange={(e) => handleDiaChange(indexDia, 'ciudad', e.target.value)}
              />

              <TextField
                label="Descripción Detallada del Día"
                fullWidth
                multiline
                rows={3}
                margin="normal"
                value={dia.descripcion}
                onChange={(e) => handleDiaChange(indexDia, 'descripcion', e.target.value)}
              />

               <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle1">Excursiones Opcionales</Typography>
                {dia.actividades.map((actividad, idx) => (
                  <Box key={idx} sx={{ mb: 2, p: 1, border: '1px solid #ccc', borderRadius: 1, position: 'relative' }}>
                    <IconButton
                      size="small"
                      style={{
                        position: 'absolute',
                        top: 5,
                        right: 5,
                        color: theme.palette.error.main
                      }}
                      onClick={() => removeActividad(indexDia, idx)}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>

                    <TextField
                      label={`Título de Excursión ${idx + 1}`}
                      fullWidth
                      margin="dense"
                      value={actividad.titulo}
                      onChange={(e) => handleActividadChange(indexDia, idx, 'titulo', e.target.value)}
                    />

                    <TextField
                      label={`Descripción de Excursión ${idx + 1}`}
                      fullWidth
                      multiline
                      rows={2}
                      margin="dense"
                      value={actividad.descripcion}
                      onChange={(e) => handleActividadChange(indexDia, idx, 'descripcion', e.target.value)}
                    />
                  </Box>
                ))}

                <Button
                  variant="outlined"
                  color='secondary'
                  startIcon={<AddIcon />}
                  onClick={() => addActividad(indexDia)}
                  sx={{ mt: 1 }}
                >
                  Agregar Excursión Opcional
                </Button>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>

      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={handleAddDia}   
      >
        Agregar Día
      </Button>
    </div>
  );
};

export default ItinerarioForm;
